export default {
    name: 'BackendNotFound',
    methods: {
        retry() {
            window.location.reload();
        }
    }
};
